import MenuContainerSdk from '../components/MenuContainer/corvid/MenuContainer.corvid';
import SiteButtonSdk from '../components/SiteButton/corvid/SiteButton.corvid';
import StripColumnsContainerSdk from '../components/StripColumnsContainer/corvid/StripColumnsContainer.corvid';
import StylableButtonSdk from '../components/StylableButton/corvid/StylableButton.corvid';
import WRichTextSdk from '../components/WRichText/corvid/WRichText.corvid';
import AnchorSdk from '@wix/thunderbolt-elements/src/components/Anchor/corvid/Anchor.corvid';
import FooterContainerSdk from '@wix/thunderbolt-elements/src/components/FooterContainer/corvid/FooterContainer.corvid';
import HeaderContainerSdk from '@wix/thunderbolt-elements/src/components/HeaderContainer/corvid/HeaderContainer.corvid';
import MediaContainerSdk from '@wix/thunderbolt-elements/src/components/MediaContainers/MediaContainer/corvid/MediaContainer.corvid';
import PageBackgroundSdk from '@wix/thunderbolt-elements/src/components/PageBackground/corvid/PageBackground.corvid';
import WPhotoSdk from '@wix/thunderbolt-elements/src/components/WPhoto/corvid/WPhoto.corvid';
import PageSdk from '@wix/thunderbolt-elements/src/thunderbolt-core-components/Page/corvid/Page.corvid';


const MenuContainer = {
  sdk: MenuContainerSdk
};

const SiteButton = {
  sdk: SiteButtonSdk
};

const StripColumnsContainer = {
  sdk: StripColumnsContainerSdk
};

const StylableButton = {
  sdk: StylableButtonSdk
};

const WRichText = {
  sdk: WRichTextSdk
};

const Anchor = {
  sdk: AnchorSdk
};

const FooterContainer = {
  sdk: FooterContainerSdk
};

const HeaderContainer = {
  sdk: HeaderContainerSdk
};

const MediaContainer = {
  sdk: MediaContainerSdk
};

const PageBackground = {
  sdk: PageBackgroundSdk
};

const WPhoto = {
  sdk: WPhotoSdk
};

const Page = {
  sdk: PageSdk
};


export const components = {
  ['MenuContainer']: MenuContainer,
  ['SiteButton']: SiteButton,
  ['StripColumnsContainer']: StripColumnsContainer,
  ['StylableButton']: StylableButton,
  ['WRichText']: WRichText,
  ['Anchor']: Anchor,
  ['FooterContainer']: FooterContainer,
  ['HeaderContainer']: HeaderContainer,
  ['MediaContainer']: MediaContainer,
  ['PageBackground']: PageBackground,
  ['WPhoto']: WPhoto,
  ['Page']: Page
};

